export function hexToRgba (hex: string, alpha = 1) {
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    let color = hex.substring(1).split('')
    if (color.length === 3) {
      color = [color[0], color[0], color[1], color[1], color[2], color[2]]
    }
    const colors: any = `0x${color.join('')}`
    return `rgba(${[(colors >> 16) & 255, (colors >> 8) & 255, colors & 255].join(', ')}, ${alpha})`
  }
  throw new Error('Bad Hex')
}
